import React from 'react'

import {
  buildFiveSegmentsTotalData,
  type FiveSegmentsTotalData,
} from '~/apps/ninesegsAnalyzer/utils/standardAnalysis'
import { type Brand } from '~/hooks/useSurveyQuery'

import { useNineSegmentsTotalData } from './useNineSegmentsTotalData'

export const useFiveSegmentsTotalData = (
  brand: Brand,
): FiveSegmentsTotalData => {
  const nineSegmentsTotalData = useNineSegmentsTotalData(brand)

  return React.useMemo(
    () => buildFiveSegmentsTotalData({ nineSegmentsTotalData }),
    [nineSegmentsTotalData],
  )
}
